<template>
  <section class="padd-0" style="height:400px;">
    <div class="container-fluid padd-0" style="height:400px;">
      <div class="col-md-12 col-sm-12 padd-0">
        <div class="half-box employer-box text-center" style="background-image:url(/img/010_55276_UP553908a846da8_FE_01AWM1J1.jpg);">
          <div class="row text-center">
            <div class="col-md-2 col-sm-6">
            </div>
            <div class="col-md-4 col-sm-6 col-xs-12">
              <div class="category-box aos-init aos-animate" data-aos="fade-up" style="height:310px; padding: 20px 30px 20px 30px;">
                <div class="category-desc">
                  <h4>{{ $t('home-banner.t1') }}</h4>
                  <div class="category-icon">
                    <img src="/img/icons-01.svg" width="110" /> 
                  </div>

                  <div class="category-detail category-desc-text">
                    <p style="color:gray;font-size:14px;text-align:left; height:75px">想要成为独当一面的专业人事获取令人心动的offer，想要让自己的专业在企业中发挥更大作用，来自世界各地的优质职业机会等你来挑。</p>
                    <p style="text-align:left"><router-link to="/jobs" style="color:#d81c00;font-size:14px;">查找自己心仪的职位 →</router-link></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 col-xs-12">
              <div class="category-box aos-init aos-animate" data-aos="fade-up" style="height:310px; padding: 20px 30px 20px 30px;">
                <div class="category-desc">
                  <h4>{{ $t('home-banner.t2') }}</h4>
                  <div class="category-icon">
                    <img src="/img/icons-02.svg" width="110" /> 
                  </div>

                  <div class="category-detail category-desc-text">
                    <p style="color:gray;font-size:14px;text-align:left; height:75px">ACCA专业人才，通晓国际准则，恪守职业道德，具有战略前瞻的眼光，帮助企业实现行业愿景。</p>
                    <p style="text-align:left"><a href="javascript:void(0)" data-toggle="modal" data-target="#followus" style="color:#d81c00;font-size:14px;">立刻发布招贤信息 →</a></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      
    </div>
  </section>
</template>
<script>
export default {
  name: 'HomeAds'
}
</script>